import { Icon } from '@blueprintjs/core';

import { ReactComponent as DeleteFilled } from '@assets/svg/delete-filled.svg';
import { ReactComponent as RefreshFilled } from '@assets/svg/refresh-filled.svg';
import { ReactComponent as SupportFilled } from '@assets/svg/support-filled.svg';

import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';

import { ProductStatus } from '@models/Product.model';

interface ProductStatusIconProps {
  status: ProductStatus;
  size?: number;
  disabled?: boolean;
}
export function ProductStatusIcon(props: ProductStatusIconProps): JSX.Element {
  const { status, size = 12, disabled = false } = props;
  if (status === ProductStatus.ACTIVE) {
    return (
      <Icon
        icon="tick-circle"
        color={disabled ? COLORS_FLAT.n600 : COLORS_FLAT.g400}
        size={size}
      />
    );
  }
  if (status === ProductStatus.DISCONTINUED) {
    return (
      <DeleteFilled
        width={size}
        height={size}
        color={disabled ? COLORS_FLAT.n600 : COLORS_FLAT.r400}
      />
    );
  }
  if (status === ProductStatus.PRESUMED_ACTIVE) {
    return <Icon icon="tick-circle" color={COLORS_FLAT.n600} size={size} />;
  }
  if (status === ProductStatus.REPLACED) {
    return <RefreshFilled width={size} height={size} />;
  }

  if (status === ProductStatus.SUPPORTED) {
    return (
      <SupportFilled
        width={size}
        height={size}
        color={disabled ? COLORS_FLAT.n600 : COLORS_FLAT.y401}
      />
    );
  }

  // if (status === ProductStatus.UNKNOWN)
  return <Icon icon="help" color={COLORS_FLAT.n600} size={size} />;
}
